/**
 * Module must be in CommonJS format
 */

const packageName = "@akelius/icon-library";

/**
 * Source folder within the package
 */
const sourceDir = "icons";

/**
 * Icon names to copy
 */
const iconList = [
  "ak-document",
  "ak-upload",
  "ak-import",
  "ak-export",
  "ak-file-copy",
  "ak-info",
  "ak-warning",
  "ak-info-filled",
  "ak-close",
  "ak-file-default",
  "ak-merge",
  "ak-plus",
  "ak-filter-list",
  "ak-close",
  "ak-menu",
  "ak-delete",
  "ak-gear",
  "ak-exit-app",
  "ak-success",
  "ak-chevron-left",
  "ak-fullscreen",
  "ak-error",
];

/**
 * Destination folder relative to your project root
 */
const destDir = "./src/assets/icons";

module.exports = {
  packageName,
  sourceDir,
  iconList,
  destDir,
};

/**
 * Run this command to copy icons
 * npx copy-lib-icons icons.config.js
 **/
